@use '../../../../styles/Colors.scss' as Colors;
@use '../../../../styles/Constants.scss' as Constants;

$var-submit-action-top-offset: -16px;
$var-shadow: 0 1px 4px 0 Colors.$col-shadow;
$var-dropdown-width: 500px;

.order-header {

	&__left {
		display: flex;
		flex-direction: row;
		gap: Constants.$val-spacing-l;
		align-items: center;
	}

	&__right {
		display: flex;
		flex-direction: row;
		gap: Constants.$val-spacing-xs;
		align-items: center;
	}

	&__cost {
		font-weight: 700;
	}

	&__status-label {
		display: flex;
		flex-direction: row;
		gap: Constants.$val-spacing-s;
	}

	&__status {
		font-weight: 700;
		background-color: Colors.$col-design-grey13;
		font-size: Constants.$val-fontSizeSmall;
		line-height: Constants.$val-lineHeightSmall;
		min-width: 100px;

		display: grid;
		place-content: center;

		&--new {
			color: Colors.$col-blue;
		}

		&--in-progress {
			color: Colors.$col-orangeBorder;
		}

		&--completed {
			color: Colors.$col-green;
		}
	}
}

.order-details-row {
	display: flex;
}

.order-detail {
	display: flex;
	flex-direction: column;
	padding: Constants.$val-spacing-m 0;
	margin-right: Constants.$val-spacing-xl;

	&__label {
		color: Colors.$col-design-grey10;
	}

	&__value {
		padding: Constants.$val-spacing-s 0;
	}
}

.order-row {
	padding: 0 Constants.$val-spacing-xs;
}

$screen-padding: Constants.$val-spacing-m;
$section-padding: Constants.$val-spacing-m;
$column-padding: Constants.$val-spacing-xs;
$sidebar-width: 72px;

.order-row-table {
	width: calc(100vw - 2 * #{$column-padding} - 2 * #{$section-padding} - 2 * #{$screen-padding} - #{$sidebar-width});
}

.datepicker-field {
	width: fit-content;
}

.radio-group {
	padding-bottom: Constants.$val-spacing-m;
}

.address-field {
	.col-md-24 {
		padding: 0;
	}
}

.item-table-footer {
	&__action {
		display: flex;
		min-height: Constants.$val-spacing-xl;
		align-items: center;
		padding-left: Constants.$val-spacing-l;
		flex-direction: row;

		& > [class^="icon-plus"] {
			margin-right: Constants.$val-spacing-s;
		}
	}

	&__dropdown {
		display: flex;
		min-height: Constants.$val-spacing-xl;
		align-items: center;
		padding-left: Constants.$val-spacing-s;
		flex-direction: row;
	}

	&__action {
		color: Colors.$col-blue;
		cursor: pointer;
		width: fit-content;
	}

	&__dropdown {
		gap: Constants.$val-spacing-s;
	}
}

.item-dropdown {
	min-width: $var-dropdown-width;
	border: 1px solid Colors.$col-greyMid;
}

.item-option {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: Constants.$val-spacing-s;
	align-items: flex-start;

	&__details {
		font-size: Constants.$val-fontSizeSmall;
		color: Colors.$col-greyFontLight;
	}

	&__to-department-container {
		display: flex;
		flex-direction: row;
		gap: 8px;
	}
}

.dropdown-white-background {
	background-color: Colors.$col-white;
}

.dropdown {
	background-color: Colors.$col-white;
	width: 320px;
}
.order-form {
	display: flex;
	flex-direction: column;

	&__menu-option {
		width: 100%;
		margin-left: Constants.$val-spacing-s;

		&__text {
			display: flex;

			&__name {
				flex: 1;
				display: flex;
				gap: Constants.$val-spacing-xs;
			}
		}

		&__sub-text {
			color: Colors.$col-greyFontLight;
			font-size: Constants.$val-fontSizeSmall;
		}
	}

	&__equipment {
		display: flex;
		align-items: center;
		gap: Constants.$val-spacing-xs;
	}
}

.field-value {
	margin-top: Constants.$val-spacing-s;
	margin-left: Constants.$val-spacing-s;
	margin-bottom: Constants.$val-spacing-s;
	font-weight: bold;
	padding: Constants.$val-spacing-xs;
}

.row-value {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.change-order-type-footer {
	display: flex;
	flex-direction: row;
	gap: 16px;
}
